global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

import Headroom from "headroom.js";

import AOS from 'aos';
import 'aos/dist/aos.css';

$(document).ready(function() {

    AOS.init({
        delay: 400,
        duration: 600,
        once: true,
    });

    // ─── Promo cards: intera card cliccabile ─────────────────────────────────────
    const $promoCards = $('.promo-section .promo-card');

    $promoCards.each(function() {
        const href = $(this).find('a').first().attr('href');
        if (href) {
            $(this).on('click', function(e) {
                if (document.body.classList.contains('fe-open')) {
                    return;
                }
                if (!$(e.target).closest('a').length) {
                    window.location.href = href;
                }
            });
        }
    });

    // Hover active class (solo desktop lg+)
    if (window.matchMedia('(min-width: 992px)').matches) {
        $promoCards.on('mouseenter', function() {
            if (document.body.classList.contains('fe-open')) {
                return;
            }
            $promoCards.removeClass('active');
            $(this).addClass('active');
        }).on('mouseleave', function() {
            if (document.body.classList.contains('fe-open')) {
                return;
            }
            $promoCards.removeClass('active');
            $promoCards.filter('.promo-card--featured').addClass('active');
        });
    }
    // ────────────────────────────────────────────────────────────────────────────

    // ─── Link PDF icon + nascondi card vuote ─────────────────────────────────────
    $('.link-pdf').each(function() {
        if ($(this).text().trim() === '') {
            $(this).closest('[class*="col-"]').hide();
        } else {
            $(this).find('a').each(function() {
                if (!$(this).find('.bi-file-earmark-pdf').length) {
                    $(this).prepend('<i class="bi bi-file-earmark-pdf me-1"></i>');
                }
            });
        }
    });
    // ────────────────────────────────────────────────────────────────────────────

    // ─── Plus blocks sequential fade-up ─────────────────────────────────────────
    if ($('.plus-section').length) {
        const $blocks = $('.plus-section .plus-block');
        $blocks.css({ opacity: 0, transform: 'translateY(28px)' });

        const plusObserver = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
                $blocks.each(function (i) {
                    const $b = $(this);
                    setTimeout(function () {
                        $b.css({
                            transition: 'opacity 0.55s ease, transform 0.55s ease',
                            opacity: 1,
                            transform: 'translateY(0)'
                        });
                    }, i * 180);
                });
                plusObserver.disconnect();
            }
        }, {threshold: 0.15});

        plusObserver.observe($('.plus-section')[0]);
    }
    // ────────────────────────────────────────────────────────────────────────────

    // ─── Responsive Collapse ────────────────────────────────────────────────────
    // Works for .plus-title (home) and .faq-title (support): desktop = all open,
    // mobile/tablet = Bootstrap collapse.
    const LG_BREAKPOINT = 992;

    function updateCollapse() {
        const isLg = window.innerWidth >= LG_BREAKPOINT;

        $('.plus-title, .faq-title').each(function () {
            const $el = $(this);
            if (isLg) {
                $el.removeAttr('data-bs-toggle data-bs-target aria-expanded aria-controls')
                   .removeClass('collapsed');
            } else {
                const $target = $el.parent().find('.collapse').first();
                if ($target.length) {
                    $el.attr({
                        'data-bs-toggle': 'collapse',
                        'data-bs-target': '#' + $target.attr('id'),
                        'aria-controls':  $target.attr('id'),
                    });
                    if (!$el.attr('aria-expanded')) {
                        $el.attr('aria-expanded', 'false');
                    }
                }
            }
        });
    }

    updateCollapse();
    $(window).on('resize', updateCollapse);
    // ────────────────────────────────────────────────────────────────────────────

    // ─── Hide empty FAQ items ────────────────────────────────────────────────────
    $('.faq-item').each(function () {
        const $title = $(this).find('.faq-title');
        if (!$title.length) {
            return;
        }
        const titleText = $title.clone().find('.faq-icon').remove().end().text().trim();
        const bodyText = $(this).find('.faq-body').text().trim();
        if (titleText && bodyText) {
            $(this).css('opacity', 1);
        } else {
            $(this).addClass('faq-item--empty');
        }
    });

    // Mostra/nascondi FAQ vuote in base allo stato dell'editor
    new MutationObserver(function() {
        const isEditing = document.body.classList.contains('fe-open');
        $('.faq-item').css('opacity', isEditing ? 1 : '');
        if (!isEditing) {
            $('.faq-item:not(.faq-item--empty)').css('opacity', 1);
        }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    // ────────────────────────────────────────────────────────────────────────────

    // Hero Swiper
    // Promo Swiper (mobile only)
    if (document.querySelector('.promo-swiper') && window.innerWidth < 992) {
        new Swiper('.promo-swiper', {
            direction: 'vertical',
            effect: 'cards',
            grabCursor: true,
            slideToClickedSlide: true,
            speed: 700,
            initialSlide: 2,
            cardsEffect: {
                perSlideOffset: 30,
                perSlideRotate: 0,
                rotate: false,
                slideShadows: false,
            },
        });
    }

    if (document.querySelector('.hero-swiper')) {
        const heroIsLg = window.innerWidth >= 992;
        const slides = Array.from(document.querySelectorAll('.hero-swiper .swiper-slide'));
        const total = slides.length;
        let activeIndex = heroIsLg ? 4 : 0;
        const stage = document.querySelector('.hero-swiper');

        // Crea i pagination dots
        const paginationEl = document.querySelector('.hero-swiper .swiper-pagination');
        if (paginationEl) {
            slides.forEach(function (_, i) {
                const dot = document.createElement('div');
                dot.className = 'swiper-pagination-bullet';
                dot.addEventListener('click', function () { goTo(i); });
                paginationEl.appendChild(dot);
            });
        }

        function updateDots() {
            if (!paginationEl) {
                return;
            }
            paginationEl.querySelectorAll('.swiper-pagination-bullet').forEach(function (dot, i) {
                dot.classList.toggle('swiper-pagination-bullet-active', i === activeIndex);
            });
        }

        const posClasses = ['slide-active', 'slide-left', 'slide-right', 'slide-far-left', 'slide-far-right', 'slide-far-far-left', 'slide-far-far-right'];
        let rafPending = false;

        function applyClasses() {
            if (rafPending) {
                return;
            }
            rafPending = true;
            requestAnimationFrame(function () {
                const half = Math.floor(total / 2);
                slides.forEach(function (slide, index) {
                    let offset = index - activeIndex;
                    if (offset > half) {
                        offset -= total;
                    }
                    if (offset < -half) {
                        offset += total;
                    }

                    const cls = offset === 0 ? 'slide-active'
                        : offset === -1 ? 'slide-left'
                            : offset === 1 ? 'slide-right'
                                : offset === -2 ? 'slide-far-left'
                                    : offset === 2 ? 'slide-far-right'
                                        : offset < -2 ? 'slide-far-far-left'
                                            : 'slide-far-far-right';

                    if (!slide.classList.contains(cls)) {
                        slide.classList.remove.apply(slide.classList, posClasses);
                        slide.classList.add(cls);
                    }
                });
                updateDots();
                rafPending = false;
            });
        }

        let transitioning = false;

        function goTo(index) {
            if (transitioning) {
                return;
            }
            transitioning = true;
            activeIndex = (index + total) % total;

            slides.forEach(function (s, i) {
                s.style.zIndex = i === activeIndex ? '10' : '1';
            });

            applyClasses();

            setTimeout(function () {
                transitioning = false;
                slides.forEach(function (s) { s.style.zIndex = ''; });
            }, 850);
        }

        // Navigation
        const btnNext = document.querySelector('.hero-swiper .swiper-button-next');
        const btnPrev = document.querySelector('.hero-swiper .swiper-button-prev');
        if (btnNext) {
            btnNext.addEventListener('click', function () { goTo(activeIndex + 1); });
        }
        if (btnPrev) {
            btnPrev.addEventListener('click', function () { goTo(activeIndex - 1); });
        }

        // Click su slide: se attiva segui href, altrimenti naviga
        slides.forEach(function (slide, index) {
            slide.addEventListener('click', function () {
                if (index === activeIndex) {
                    const href = slide.querySelector('.hero-card') && slide.querySelector('.hero-card').dataset.href;
                    if (href) {
                        window.location.href = href;
                    }
                } else {
                    goTo(index);
                }
            });
        });

        // Touch/mouse drag
        let touchStartX = 0;

        stage.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
            const diff = touchStartX - e.changedTouches[0].clientX;
            if (Math.abs(diff) > 50) {
                goTo(diff > 0 ? activeIndex + 1 : activeIndex - 1);
            }
        });

        stage.classList.add('swiper-initialized');
        applyClasses();

        requestAnimationFrame(function () {
            // Equalizza hero-card-body
            const bodies = stage.querySelectorAll('.hero-card-body');
            let maxBodyH = 0;
            bodies.forEach(function (el) { maxBodyH = Math.max(maxBodyH, el.offsetHeight); });
            bodies.forEach(function (el) { el.style.minHeight = maxBodyH + 'px'; });

            // Altezza slider = card più alta + padding
            const cards = stage.querySelectorAll('.hero-card');
            let maxCardH = 0;
            cards.forEach(function (el) { maxCardH = Math.max(maxCardH, el.offsetHeight); });
            stage.style.height = (maxCardH + 80) + 'px';
        });
    }

    if($('.headroom').length > 0){
        let headroomEl = document.querySelector("header");
        let options = {
            offset : 80,
        }
        let headroom  = new Headroom(headroomEl,options);
        headroom.init();
    }

    // To-top button
    const toTopBtn = $('#to-top');
    $(window).scroll(function(){
        if ($(window).scrollTop() > 300) {
            toTopBtn.fadeIn();
        } else {
            toTopBtn.fadeOut();
        }
    });

    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });

    let headerHeight;
    if (!isMobile()) {
        // let headerSubMenu = $(".submenu").outerHeight();
        // $(".submenu").outerHeight(headerHeight + headerSubMenu);
        headerHeight = $("header").outerHeight();
        $(".header__nav-wrapper").css("top",headerHeight);
    }

    function toggleMenuOpenClose() {
        let body = $('body');
        let headerNavWrapper = $('.header__nav-wrapperMobile');
        if (headerNavWrapper.hasClass('open')) {
            body.removeClass('no-scroll-y');
            headerNavWrapper.removeClass('open');
            // headerOverlay.removeClass('open');
        } else {
            body.addClass('no-scroll-y');
            headerNavWrapper.addClass('open');
            // headerOverlay.addClass('open');
        }
        $('#burger-button i').toggleClass("fa-bars fa-x");
    }

    let contrMenuSub = $(".menuSubCat");
    let linkSub = $(".mobile-opener");

    if (!isMobile()) {

        linkSub.click(function (e) {
            e.preventDefault();
        })

        let closeMenuTimer;
        let body = $('body');
        linkSub.hover(function (e) {
            linkSub.addClass("link-active");
            clearTimeout(closeMenuTimer);
            contrMenuSub.stop(true, true).slideDown(300);
            body.addClass('overflow-hidden');
            $("header").toggleClass("headroom-open");
            e.stopPropagation();
        }, function (e) {
            linkSub.removeClass("link-active");
            $("header").toggleClass("headroom-open");
            body.removeClass('overflow-hidden');
            closeMenuTimer = setTimeout(function () {
                contrMenuSub.stop(true, true).slideUp('fast');
            }, 100);
            e.stopPropagation();
        });

        contrMenuSub.hover(function (e) {
            linkSub.addClass("link-active");
            clearTimeout(closeMenuTimer);
            $("header").toggleClass("headroom-open");
            body.addClass('overflow-hidden');
            e.stopPropagation();
        }, function (e) {
            linkSub.removeClass("link-active");
            $("header").toggleClass("headroom-open");
            body.removeClass('overflow-hidden');
            closeMenuTimer = setTimeout(function () {
                contrMenuSub.stop(true, true).slideUp('fast');
            }, 100);
            e.stopPropagation();
        });
    } else {
        let burgerButton = $('.burger-button');
        const closerX = $('#closerX');

        closerX.click(function (e) {
            e.preventDefault();
            toggleMenuOpenClose();
        })

        burgerButton.on('click', function(e) {
            e.preventDefault();
            toggleMenuOpenClose();
        });

        let mobileOpener = $('.mobile');
        let mobileOpenerSpan = $('.mobile >span');
        let categoriesMobile = $('.cat_subHeader');


        mobileOpenerSpan.on('click', function (e) {
            e.preventDefault()
            if (mobileOpener.hasClass('open')){
                mobileOpener.removeClass('open');
                categoriesMobile.slideUp();
            } else {
                mobileOpener.addClass('open');
                categoriesMobile.slideDown();

            }
        })

        let catopenerSpan = $(".cat-opener >span");

        catopenerSpan.on('click', function (e) {
            e.preventDefault()
            if ($(this).parent().hasClass('open')){
                $(this).parent().removeClass('open');
                $(this).parent().children('.ul-products').stop(true, true).slideUp()
            } else {
                $(this).parent().addClass('open');
                $(this).parent().children('.ul-products').stop(true, true).slideDown()

            }
        })

    }


    if ($('header.headroom').length > 0) {
        let headroomEl = document.querySelector("header");
        let options = {
            onNotTop: function (mainEl) {
                document.querySelector("main").classList.add('main--has-scroll');
            },
            onTop: function (mainEl) {
                document.querySelector("main").classList.remove('main--has-scroll');
                if (!isMobile()) {
                    headerHeight = $("header").outerHeight();
                    contrMenuSub.css("top",headerHeight);
                }
            },
            onPin : function() {
                if (!isMobile()) {
                    headerHeight = $("header").outerHeight();
                    contrMenuSub.css("top",headerHeight);
                }
            },
            offset : 100,
        }
        const headerHeadroom = new Headroom(headroomEl, options);
        headerHeadroom.init();
        global.headerHeadroom = headerHeadroom;

        $(window).on('scroll.headroom-bg', function() {
            const threshold = window.innerHeight * 1.3;
            headroomEl.classList.toggle('headroom--bg-active', $(window).scrollTop() > threshold);
        });
    }

    function isMobile() {
        const minWidth = 1200; // Minimum width for desktop devices
        return window.innerWidth <= minWidth || screen.width <= minWidth;
    }


    // ─── Orb comet: stella cadente circolare su fibra-section ────────────────────
    (function () {
        const orbCanvas = document.getElementById('orb-comet-canvas');
        const fibraSection = document.querySelector('.fibra-section');
        if (!orbCanvas || !fibraSection) {
            return;
        }

        // Canvas è 24px più grande dell'orb su ogni lato (inset:-12px)
        // orb = 260px → canvas = 284px, centro = 142, raggio percorso = 130 (= 260/2)
        const ORB = 260;
        const PAD = 12;
        const SIZE = ORB + PAD * 2;
        const CX = SIZE / 2;
        const CY = SIZE / 2;
        const R = ORB / 2;          // raggio del bordo dell'orb
        const DURATION = 3100;      // ms per un giro completo
        const TAIL_ARC = Math.PI * 0.95; // lunghezza coda in radianti
        const TAIL_STEPS = 80;      // passi per costruire il path (non visibili come punti)

        orbCanvas.width  = SIZE;
        orbCanvas.height = SIZE;

        const ctx = orbCanvas.getContext('2d');
        let animId = null;
        let startTime = null;

        // giro completo + ~15% extra prima di fermarsi
        const OVERSHOOT = 1;

        function drawComet(progress) {
            ctx.clearRect(0, 0, SIZE, SIZE);

            // angolo: parte dal top (−π/2), percorre OVERSHOOT giri in senso orario
            const angle = progress * Math.PI * 2 * OVERSHOOT - Math.PI / 2;

            // ─── Coda: linea con spessore e opacità crescenti ─────────────────
            // Disegna N segmenti brevi lungo l'arco, ognuno con spessore e alfa crescenti
            const SEG = TAIL_STEPS;
            for (let i = 0; i < SEG; i++) {
                const t0 = i / SEG;
                const t1 = (i + 1) / SEG;
                const a0 = angle - TAIL_ARC * (1 - t0);
                const a1 = angle - TAIL_ARC * (1 - t1);
                const sx = CX + Math.cos(a0) * R;
                const sy = CY + Math.sin(a0) * R;
                const ex = CX + Math.cos(a1) * R;
                const ey = CY + Math.sin(a1) * R;
                ctx.beginPath();
                ctx.moveTo(sx, sy);
                ctx.lineTo(ex, ey);
                ctx.strokeStyle = 'rgba(190, 150, 255, ' + (t1 * 0.65) + ')';
                ctx.lineWidth = t1 * 2.5;
                ctx.lineCap = 'round';
                ctx.stroke();
            }

            // ─── Testa: glow + core ────────────────────────────────────────────
            const hx = CX + Math.cos(angle) * R;
            const hy = CY + Math.sin(angle) * R;

            const glow = ctx.createRadialGradient(hx, hy, 0, hx, hy, 10);
            glow.addColorStop(0,   'rgba(230, 200, 255, 0.95)');
            glow.addColorStop(0.35,'rgba(170, 110, 255, 0.55)');
            glow.addColorStop(1,   'rgba(100,  60, 200, 0)');
            ctx.beginPath();
            ctx.arc(hx, hy, 10, 0, Math.PI * 2);
            ctx.fillStyle = glow;
            ctx.fill();

            ctx.beginPath();
            ctx.arc(hx, hy, 2.5, 0, Math.PI * 2);
            ctx.fillStyle = 'rgba(255, 248, 255, 1)';
            ctx.fill();
        }

        function animate(ts) {
            if (!startTime) {
                startTime = ts;
            }
            const elapsed = ts - startTime;
            const progress = (elapsed % DURATION) / DURATION;

            drawComet(progress);
            animId = requestAnimationFrame(animate);
            // a fine animazione il canvas rimane con l'ultimo frame disegnato
        }

        let triggered = false;
        const observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting && !triggered) {
                triggered = true;
                observer.disconnect();
                startTime = null;
                animId = requestAnimationFrame(animate);
            }
        }, {threshold: 0.5});

        observer.observe(fibraSection);
    })();

    let mobileFooterOpener = $('#mobileFooterOpener')
    let footerInfos = $('#footerInfos')

    mobileFooterOpener.click(function (e) {
        e.preventDefault()
        if (mobileFooterOpener.hasClass('open')) {
            footerInfos.stop().slideUp(300);
            mobileFooterOpener.removeClass('open')
        } else {
            footerInfos.stop().slideDown(300);
            mobileFooterOpener.addClass('open')
            let n = $(document).height();
            // console.log(n)
            $('html, body').animate({scrollTop: n}, 200);
        }
    })



// ─── Password reveal toggle ───────────────────────────────────────────────────
    document.querySelectorAll('input[type="password"]').forEach(function(input) {
        const parent = input.parentElement;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Mostra/nascondi password');
        btn.className = 'password-toggle-btn';
        btn.innerHTML = '<i class="bi bi-eye"></i>';

        if (parent.classList.contains('input-group')) {
            const span = document.createElement('span');
            span.className = 'input-group-text';
            span.appendChild(btn);
            input.after(span);
        } else {
            parent.style.position = 'relative';
            btn.classList.add('password-toggle-btn--abs');
            input.after(btn);
        }

        btn.addEventListener('click', function() {
            const show = input.type === 'password';
            input.type = show ? 'text' : 'password';
            btn.querySelector('i').className = show ? 'bi bi-eye-slash' : 'bi bi-eye';
        });
    });
});
